import React from "react";
import PropTypes from "prop-types";
import { Field } from "formik";
import Input, { masks } from "../../Input/Input";
import { getFieldError } from "../hooks/fieldUtils";

function InputField(props) {
    const { className, fieldName, type, helperText, capitalize, uppercase, lowercase, onChange, label, fullWidth, ...rest } = props;

    const onChangeHandler = (event, field, form) => {
        field.onChange(event);
        if (onChange && typeof onChange === "function") {
            onChange(field.name, event && event.target && event.target.value, form);
        }
    };

    return (
        <Field type={type} name={fieldName}>
            {({ field, form }) => {
                const error = getFieldError({ form, field });

                return (
                    <Input
                        {...field}
                        {...rest}
                        id={field.name}
                        onChange={(e) => onChangeHandler(e, field, form)}
                        type={type}
                        label={label}
                        error={error}
                        helperText={helperText}
                        className={className}
                        capitalize={capitalize}
                        uppercase={uppercase}
                        lowercase={lowercase}
                    />
                );
            }}
        </Field>
    );
}

InputField.propTypes = {
    fieldName: PropTypes.string.isRequired,
    type: PropTypes.string,
    autoComplete: PropTypes.string,
    fullWidth: PropTypes.bool,
    helperText: PropTypes.string,
    capitalize: PropTypes.bool,
    uppercase: PropTypes.bool,
    lowercase: PropTypes.bool,
    mask: PropTypes.oneOf([masks.ssn, masks.alienRegistrationNo, masks.phoneNumber, masks.twoDigits]),
    numeric: PropTypes.bool,
    currency: PropTypes.bool,
    onChange: PropTypes.func,
    label: PropTypes.node,
    className: PropTypes.string,
    dark: PropTypes.bool,
    light: PropTypes.bool,
    compact: PropTypes.bool,
};

InputField.defaultProps = {
    type: "text",
    autoComplete: "off",
    fullWidth: true,
    helperText: undefined,
    capitalize: false,
    uppercase: false,
    lowercase: false,
    mask: undefined,
    numeric: false,
    currency: false,
    onChange: undefined,
    label: undefined,
    className: undefined,
    dark: false,
    light: false,
    compact: false,
};

export default InputField;
